import React from 'react';
import { Button } from '@fieldnation/platform-components';

import styles from './styles.scss';
import { PartEntry } from './types.d';
import { formatReturnCell } from './utils';
import { getCarrierFromTrackingNumber } from '../ShipmentForm/utils';

interface Props {
  parts: PartEntry[];
  showAddPart: boolean;
  onAddPart: () => void;
  onEdit: (id: number) => void;
  onCopy: (id: number) => void;
  onDelete: (id: number) => void;
}

const renderTrackingLink = (
  label: string,
  trackingNumber: string,
): JSX.Element => {
  const { trackingLink } = getCarrierFromTrackingNumber(trackingNumber);
  return (
    <span>
      {`${label}: `}
      {trackingLink ? (
        <a href={trackingLink} target="_blank" rel="noopener noreferrer">
          {trackingNumber}
        </a>
      ) : (
        trackingNumber
      )}
    </span>
  );
};

const AddedPartsTable = ({
  parts,
  showAddPart,
  onAddPart,
  onEdit,
  onCopy,
  onDelete,
}: Props): JSX.Element => (
  <div>
    <div className={styles['table-header-row']}>
      <p className={styles['table-header-label']}>{`Added parts (${parts.length})`}</p>
      {showAddPart && (
        <Button
          id="addPartButton"
          label="Add part"
          icon="icon-plus"
          type="link"
          onClick={onAddPart}
        />
      )}
    </div>
    <table className={styles['parts-table']}>
      <thead>
        <tr>
          <th>ID</th>
          <th>Number</th>
          <th>Description</th>
          <th>Return</th>
          <th>Tracking</th>
          <th aria-label="Actions" />
        </tr>
      </thead>
      <tbody>
        {parts.map(({ id, part, usage }) => (
          <tr key={id}>
            <td>{part.externalId}</td>
            <td>{part.externalNumber}</td>
            <td>{part.description}</td>
            <td>{formatReturnCell(part)}</td>
            <td>
              <div className={styles['tracking-cell']}>
                {part.trackingNumber && renderTrackingLink('Ship', part.trackingNumber)}
                {usage.returnTracking && renderTrackingLink('Return', usage.returnTracking)}
              </div>
            </td>
            <td>
              <div className={styles['row-actions']}>
                <Button
                  icon="deleteHollow"
                  onClick={() => onDelete(id)}
                  shouldUseIconComponent
                  type="text"
                />
                <Button
                  icon="copy"
                  onClick={() => onCopy(id)}
                  shouldUseIconComponent
                  type="text"
                />
                <Button
                  icon="edit"
                  onClick={() => onEdit(id)}
                  shouldUseIconComponent
                  type="text"
                />
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default AddedPartsTable;
